
const atencionDescanso = localStorage.getItem('descanso')
  ? JSON.parse(localStorage.getItem('descanso'))
  : [];

export default {
  state:{
    descanso: atencionDescanso[0],
  },

  
  mutations: {

    setDescanso( state, data) {
      state.descanso = data
    },

    resetDescanso( state ) {
      state.descanso = []
    }
  }
}
  